import Prism from 'prismjs';
import 'prismjs/components/prism-json';
import 'prismjs/themes/prism.css';
import { createSignal, onMount, createEffect } from 'solid-js';
import type { Component } from 'solid-js';

interface JsonHighlighterProps {
  data: any;
  class?: string;
  maxHeight?: string;
  maxWidth?: string;
}

const JsonHighlighter: Component<JsonHighlighterProps> = (props) => {
  const [highlightedCode, setHighlightedCode] = createSignal('');
  let codeRef: HTMLElement | undefined;

  const formatData = () => {
    return JSON.stringify(props.data, null, 2);
  };

  const highlightCode = () => {
    const code = formatData();
    const highlighted = Prism.highlight(code, Prism.languages.json, 'json');
    setHighlightedCode(highlighted);
  };

  onMount(() => {
    highlightCode();
  });

  createEffect(() => {
    if (props.data) {
      highlightCode();
      if (codeRef) {
        codeRef.innerHTML = highlightedCode();
      }
    }
  });

  return (
    <div class="relative">
      <pre
        class={`overflow-auto rounded-md bg-gray-50 p-4 text-base ${props.class || ''}`}
        style={{
          'max-height': props.maxHeight || '24rem',
          'max-width': props.maxWidth || '80vw',
        }}>
        <code ref={codeRef} class="language-json" />
      </pre>
    </div>
  );
};

export default JsonHighlighter;
